import { Button, CssBaseline, Grid } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import DocumentCard from "../../../../components/V3/DocumentCard";
import UploadCard from "../../../../components/V3/UploadCard";
import customerIco from "../../../../assets/tabs/customerCard.svg";
import licenseIco from "../../../../assets/tabs/drivingLicense.svg";
import electricityIco from "../../../../assets/tabs/electricityIco.svg";
import otherIco from "../../../../assets/tabs/otherProofIco.svg";
import voterIdFront from "../../../../assets/tabs/voterFrontIco.svg";
import voterIdBack from "../../../../assets/tabs/voterBackIco.svg";
import { uploadDocument } from "../../../../api/agent";
import SuccessCard from "../../../../components/SuccessCard";
import { LoanContext } from "../../../../Contexts/LoanJourneyContext";
import useApplication from "../../../../hooks/useApplication";
import MenuAppBar from "../../../../components/Appbar";
import { useNavigate } from "react-router-dom";
import MixPanelAudit from "../../../../util/MixPanelAudit";
import { UserContext } from "../../../../Contexts/UserContext";
import { GlobalContext } from "../../../../Contexts/GlobalContext";
import { l } from "../../../../util/languageConvertor";
import RejectionPopup from "../../../../components/V3/RejectionPopup";
import addmoreIco from "../../../../assets/tabs/addmoreIco.svg";
import AppTour from "../../AppTour/AppTour";

const Customer = ({ application_id, openStatus }) => {
  const { user } = useContext(UserContext);
  const { journeyState } = useContext(LoanContext);
  const [journeyData, setJourneyData] = journeyState;
  const { langState, docPopupState } = useContext(GlobalContext);
  const [docPopup, setDocPopup] = docPopupState;
  const [lang, setLang] = langState;
  const [customer_other_documents, setOtherDocs] = useState([]);

  const { getApplicationDetails } = useApplication();
  const [loading, setLoading] = useState("");
  const navigate = useNavigate();

  const handleUpload = async (file, name, overRide) => {
    setLoading(name);
    try {
      let { data } = await uploadDocument(
        {
          document_included_g: true,
          docs: [
            {
              name,
              file,
            },
          ],
        },
        application_id,
        `?type=customer&override=${overRide}`
      );
      if (data?.mandatory_completed) {
        setDocPopup({ open: true, type: "DONE" });
      }
      getApplicationDetails(application_id, true);
    } catch (error) {}
    setLoading("");
  };

  useEffect(() => {
    let doc = journeyData?.customer_documents?.customer_other_documents;
    if (doc?.length > 0) {
      setOtherDocs([...doc, { name: `customer_other_documents_${doc?.length}` }]);
    } else {
      setOtherDocs([{ name: "customer_other_documents_1" }]);
    }
  }, [journeyData]);

  return (
    <div>
      <MenuAppBar
        home={false}
        bigText={"Pre-Disbursement"}
        action={() => {
          navigate(`/draft-applications`);
        }}
        shadow={true}
        leftContent={
          <Button
            color="secondary"
            onClick={() => {
              MixPanelAudit.intercept("check_status_click", {
                distinct_id: user?.mobile_number[0],
                agent_name: user?.name,
                application_id,
              });
              openStatus();
            }}
          >
            {l("Check Status", lang)}
          </Button>
        }
      />
      <CssBaseline />
      <Grid container spacing={2} className="mt-1">
        <Grid item xs={6} sm={6}>
          <DocumentCard
            tempState={
              journeyData?.customer_documents?.customer_photo?.slice(-1)[0]
                ?.fileLink || ""
            }
            isUpload={
              journeyData?.customer_documents?.customer_photo?.length > 0
            }
            status={
              journeyData?.customer_documents?.customer_photo?.slice(-1)[0]
                ?.isApproved
            }
            text={l("Customer photo", lang)}
            isLoading={loading === "customer_photo"}
            isRequired={true}
            icon={customerIco}
            data={journeyData?.customer_documents?.customer_photo?.slice(-1)[0]}
            setFile={(file) => {
              handleUpload(file, "customer_photo", true);
            }}
          />
        </Grid>
        <Grid item xs={6} sm={6}>
          <DocumentCard
            tempState={
              journeyData?.customer_documents?.driving_license?.slice(-1)[0]
                ?.fileLink || ""
            }
            isUpload={
              journeyData?.customer_documents?.driving_license?.length > 0
            }
            status={
              journeyData?.customer_documents?.driving_license?.slice(-1)[0]
                ?.isApproved
            }
            text={l("Driving License", lang)}
            icon={licenseIco}
            isRequired={true}
            isLoading={loading === "driving_license"}
            data={
              journeyData?.customer_documents?.driving_license?.slice(-1)[0]
            }
            setFile={(file) => {
              handleUpload(file, "driving_license", true);
            }}
          />
        </Grid>
        {/* <Grid item xs={6} sm={6}>
          <DocumentCard
            text={"Electricity Bill"}
            isRequired={true}
            icon={electricityIco}
            tempState={
              journeyData?.documents?.electricity_bill?.slice(-1)[0]
                ?.fileLink || ""
            }
            isUpload={journeyData?.documents?.electricity_bill?.length > 0}
            isLoading={loading === "electricity_bill"}
            status={
              journeyData?.documents?.electricity_bill?.slice(-1)[0]?.isApproved
            }
            setFile={(file) => {
              handleUpload(file, "electricity_bill", true);
            }}
          />
        </Grid> */}
        <Grid item xs={6} sm={6}>
          <DocumentCard
            text={l("House ownership proof(Electricity bill)", lang)}
            icon={otherIco}
            isRequired={true}
            tempState={
              journeyData?.documents?.other_ownership_proof?.slice(-1)[0]
                ?.fileLink || ""
            }
            isUpload={journeyData?.documents?.other_ownership_proof?.length > 0}
            status={
              journeyData?.documents?.other_ownership_proof?.slice(-1)[0]
                ?.isApproved
            }
            data={journeyData?.documents?.other_ownership_proof?.slice(-1)[0]}
            isLoading={loading === "other_ownership_proof"}
            setFile={(file) => {
              handleUpload(file, "other_ownership_proof", true);
            }}
          />
        </Grid>
        {/* <Grid item xs={6} sm={6}>
          <DocumentCard
            text={"Voter ID Front"}
            icon={voterIdFront}
            tempState={
              journeyData?.customer_documents?.voter_id_front?.slice(-1)[0]
                ?.fileLink || ""
            }
            isUpload={
              journeyData?.customer_documents?.voter_id_front?.length > 0
            }
            status={
              journeyData?.customer_documents?.voter_id_front?.slice(-1)[0]
                ?.isApproved
            }
            isLoading={loading === "voter_id_front"}
            setFile={(file) => {
              handleUpload(file, "voter_id_front", true);
            }}
          />
        </Grid>
        <Grid item xs={6} sm={6}>
          <DocumentCard
            text={"Voter ID Back"}
            icon={voterIdBack}
            tempState={
              journeyData?.customer_documents?.voter_id_back?.slice(-1)[0]
                ?.fileLink || ""
            }
            isUpload={
              journeyData?.customer_documents?.voter_id_back?.length > 0
            }
            status={
              journeyData?.customer_documents?.voter_id_back?.slice(-1)[0]
                ?.isApproved
            }
            isLoading={loading === "voter_id_back"}
            setFile={(file) => {
              handleUpload(file, "voter_id_back", true);
            }}
          />
        </Grid> */}
        {/* {customer_other_documents?.map((doc, index) => {
          return (
            <Grid item xs={6} sm={6}>
              <DocumentCard
                text={
                  index === customer_other_documents?.length - 1
                    ? l("Add More", lang)
                    : doc?.name?.replaceAll("_", " ")
                }
                icon={addmoreIco}
                tempState={doc?.fileLink || ""}
                isUpload={index === customer_other_documents?.length - 1 ? false : true}
                status={doc?.isApproved}
                data={doc}
                isLoading={loading === "customer_other_documents"}
                setFile={(file) => {
                  handleUpload(file, "customer_other_documents", false);
                }}
              />
            </Grid>
          );
        })} */}
      </Grid>
    </div>
  );
};

export default Customer;
